import Loader from 'common/modules/loader'
import { select } from 'redux-saga/effects'
import { focusPrompt } from './frameUtilities'

export default function* watchFrameSubmit({ email }) {
    const defaultPopup = yield select(Loader.selectors.getDefaultPopup)

    yield focusPrompt('/registration', {
        signupEmail: email,
        popupId: defaultPopup?.id,
    })
}
